module.exports = __webpack_public_path__ + "components/flag/static/square/cw-4b44313c7cb424d5a9c83d35044904fd.svg";